import styled from 'styled-components';
import { Autocomplete } from '@attain-sre/attain-design-system';

export const SelectAutoCompleteGroup = styled(Autocomplete)`
  width: 223px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    font-family: Calibre-Regular, sans-serif;
  }
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
`;
